// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Table } from '../common/table';
import type { ColumnType } from '../common/table/Table';
import type { CropImportRowError } from './parseCropUpload';

interface Props {
  readonly parseErrors: readonly CropImportRowError[];
}

export default function ParseErrorsTable({ parseErrors }: Props) {
  const rows: number[] = [];
  const cols: string[] = [];
  const errors: string[] = [];
  for (const error of parseErrors) {
    rows.push(error.rowIndex);
    cols.push(error.colHeader);
    errors.push(error.error);
  }
  const columns: ColumnType[] = [
    {
      name: 'Row',
      values: rows,
      minWidth: true,
    },
    {
      name: 'Column',
      values: cols,
      visibleAt: 'sm',
    },
    {
      name: 'Error',
      values: errors,
      wrapOverFlow: true,
    },
  ];

  return <Table columns={columns} />;
}
